import './driversFilter.css';
import DropDown from "../../../../shared/drop-down/dropDown";
import Slider from "../../../../shared/slider/slider";
import Checkbox from "../../../../shared/checkbox/checkbox";
import {useState} from "react";
const DriversFilter = () => {

    const [trip, setTrip] = useState(10);
    const [km, setKm] = useState(2500);
    const [ratings, setRatings] = useState(2);

    const handleTrip = (val) => setTrip(val);
    const handleKm = (val) => setKm(val);
    const handleRatings = (val) => setRatings(val);

    return(
        <ul className={'driver-filter-list filter-list round-corner-8'}>
            <li>
                <div className="filter-title">No of Trips</div>
                <div className="margin-b-30"><DropDown selected={'This Week'} list={['This week', 'This month', 'This year']}/></div>
                <div className="">
                    <div className="margin-b-20"><Slider onChange={handleTrip} value={20} min={0} max={50}/></div>
                    <div className="sf-medium">{trip}</div>
                </div>
            </li>
            <li>
                <div className="filter-title">Alerts per 100 Kms</div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>Less than 30</label>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>Less than 60</label>
                </div>
                <div className="dark-grey-color flex ">
                    <Checkbox checked={false}/>
                    <label className={'margin-l-10'}>Less than 100</label>
                </div>
            </li>
            <li>
                <div className="filter-title">Distance Driven</div>
                <div className="margin-b-30"><DropDown selected={'All'} list={['All', '100km', '200km']}/></div>
                <div className="">
                    <div className="margin-b-20"><Slider onChange={handleKm} value={2500} min={0} max={5000}/></div>
                    <div className="sf-medium">{km}km</div>
                </div>
            </li>
            <li>
                <div className="filter-title margin-b-15">Driver Score</div>
                <div className="">
                    <div className="margin-b-20"><Slider onChange={handleRatings} step={0.5} value={2.0} min={0} max={5}/></div>
                    <div className="sf-medium">{ratings}</div>
                </div>
            </li>
            {/*<li>*/}
            {/*    <div className="filter-title">Status</div>*/}
            {/*    <div className="dark-grey-color flex margin-b-20">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Active</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex margin-b-20">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Inactive</label>*/}
            {/*    </div>*/}
            {/*</li>*/}
            {/*<li>*/}
            {/*    <div className="filter-title">Current Location (State)</div>*/}
            {/*    <div className="dark-grey-color flex margin-b-20">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Andhra Pradesh</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex margin-b-20">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Assam</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex margin-b-20">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Chandigharh</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex margin-b-20">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Delhi</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex margin-b-20">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Gujarat</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Karnataka</label>*/}
            {/*    </div>*/}
            {/*</li>*/}
            <li>
                <div className="filter-title">Best & Worst</div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>All</label>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>Top 20%</label>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>Bottom 20%</label>
                </div>
            </li>
            {/*<li>*/}
            {/*    <div className="filter-title">Alertness</div>*/}
            {/*    <div className="dark-grey-color flex margin-b-20">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Good</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex margin-b-20">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Ok</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex margin-b-20">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Bad</label>*/}
            {/*    </div>*/}
            {/*</li>*/}
        </ul>
    )
}

export default DriversFilter;
